import React from 'react'
import { useSelector } from 'react-redux'

import './style.scss'

const LoadingInit = () => {
    const loading = useSelector(state => state.AppReducer.loadingInit)

    if (loading === 0) {
        return null
    }

    return (
        <div className="loading-init">
            <div className="loader">LoadingInit...</div>
        </div>
    )
}

export default LoadingInit
